import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    USER_LOGOUT,

    USER_DETAILS_REQUEST,
    USER_DETAILS_SUCCESS,
    USER_DETAILS_FAIL,
    USER_DETAILS_RESET,

    USER_UPDATE_PROFILE_REQUEST,
    USER_UPDATE_PROFILE_SUCCESS,
    USER_UPDATE_PROFILE_FAIL,
    USER_UPDATE_PROFILE_RESET,
} from '../constants/userConstants'

import {
    VIDEO_LIST_RESET,
} from '../constants/videoConstants'

import{
    PROXY_SERVER,
} from '../constants/proxyConstants'

import axios from 'axios'

export const login =(username,password)=>async(dispatch)=>{
    try{
        dispatch({
            type: USER_LOGIN_REQUEST
        })

        const config = {
            headers:{
                'Content-type': 'application/json'
            }
        }

        const {data} = await axios.post(
            `${PROXY_SERVER}/api/users/login/`,
            {'username':username,'password':password},
            config
        )

        dispatch({
            type:USER_LOGIN_SUCCESS,
            payload:data
        })

        localStorage.setItem('userInfo',JSON.stringify(data))


    }catch(error){
        dispatch({
            type:USER_LOGIN_FAIL,
            payload:error.response && error.response.data.detail
                ? error.response.data.detail
                :error.message,
        })
    }
}

export const logout = () =>(dispatch) =>{
    localStorage.removeItem('userInfo')
    dispatch({ type:USER_LOGOUT })
    dispatch({ type:USER_DETAILS_RESET })
    dispatch({ type:VIDEO_LIST_RESET })
}



export const getUserDetails =(id)=>async(dispatch,getState)=>{
    try{
        dispatch({
            type: USER_DETAILS_REQUEST
        })

        const {
            userLogin: {userInfo},
        } = getState()

        const config = {
            headers:{
                'Content-type': 'application/json',
                Authorization : `Bearer ${userInfo.token}`
            }
        }

        const {data} = await axios.get(
            //不要省掉符號不然很多都會漏掉
            `${PROXY_SERVER}/api/users/${id}/`,
            config
        )
      

        dispatch({
            type:USER_DETAILS_SUCCESS,
            payload:data
        })


    }catch(error){
        dispatch({
            type:USER_DETAILS_FAIL,
            payload:error.response && error.response.data.detail
                ? error.response.data.detail
                :error.message,
        })
    }
}





export const updateUserProfile =(user)=>async(dispatch,getState)=>{
    try{
        dispatch({
            type: USER_UPDATE_PROFILE_REQUEST
        })

        const {
            userLogin: {userInfo},
        } = getState()

      

        const config = {
            headers:{
                'Content-type': 'application/json',
                Authorization : `Bearer ${userInfo.token}`
            }
        }

        const {data} = await axios.put(
            `${PROXY_SERVER}/api/users/profile/update`,
            user,
            config
        )

        dispatch({
            type:USER_UPDATE_PROFILE_SUCCESS,
            payload:data
        })

        dispatch({
            type:USER_LOGIN_SUCCESS,
            payload:data
        })

        localStorage.setItem('userInfo',JSON.stringify(data))

    }catch(error){
        dispatch({
            type:USER_UPDATE_PROFILE_FAIL,
            payload:error.response && error.response.data.detail
                ? error.response.data.detail
                :error.message,
        })
    }
}
